import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';


import moment from 'moment';
// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ReadingSessionEventsFeed from './readingSessionEventsFeed';

import {
  fetchCurrentReadingSessions,
  clearCurrentReadingSessions
} from '../../modules/reader';

export class ReadingSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.startOpen
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    const {session} = this.props;
    const {open} = this.state;
    if (!session) {
      return (
        <p role="status">Loading reading session…</p>
      );
    } else {
      return (
        <section className="br-reading-session">
          <button type="button" className="br-reading-session__toggle"
            onClick={this.toggleOpen} aria-expanded={!!open}
            aria-controls={`reading-session-${session._id}`}>
            <span aria-hidden="true">{open ? '▾' : '▸'}</span>
            <span>{`${session.eventCount || 0} events over ${moment.duration(new Date(session.updatedAt) - new Date(session.createdAt)).humanize()}`}</span>
            <time dateTime={session.updatedAt}>{moment(new Date(session.updatedAt)).fromNow()}</time>
          </button>
          {open && <div id={`reading-session-${session._id}`} className="br-reading-session__events">
            <ReadingSessionEventsFeed session={session} />
          </div>}
        </section>
      );
    }
  }

  // custom methods
  toggleOpen = () => {
    this.setState(state => ({open: !state.open}));
  }

}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  currentReader: state.reader.currentReader,
  currentReadingSessions: state.reader.currentReadingSessions,
  readingSessionEventData: state.reader.readingSessionEventData
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCurrentReadingSessions,
  clearCurrentReadingSessions,
  changePage: (newPage) => push(newPage)
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReadingSession))
